import React from "react";
import { Col } from "react-bootstrap";
import { GalleryItem as GalleryItemType } from "../../cms/pages/types/GalleryItem";
import FileCard from "./FileCard";
import ImageCard from "./ImageCard";
import ProductCard from "./ProductCard";

export const GalleryItem = ({ item }: { item: GalleryItemType }) => {
    return <Col className="mb-4">
        {item.type === 'file' && <FileCard item={item} />}
        {(item.type === 'image' || !item.type) && <ImageCard item={item} />}
        {(item.type === 'product' || !item.type) && <ProductCard item={item} />}
    </Col>;
};